// extracted by mini-css-extract-plugin
module.exports = {"cover":"FJCover_cover__3szS0"};